import { useCallback, useState } from 'react'

export const usePopup = () => {
  const [isOpened, setOpened] = useState(false)

  const togglePopup = useCallback(() => {
    setOpened((prevState) => !prevState)
  }, [])

  return {
    isOpened,
    setOpened,
    togglePopup,
  }
}
